import { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Share, SquarePlus, Check } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { IconBadge } from '@/components/ui/card'

/* Spec PWA-001 — US-004 cenario 2: iOS nao tem convite nativo; instrucao ilustrada em 3 passos. */
export function IosInstallDialog({ open, onClose }: { open: boolean; onClose: () => void }) {
    const { t } = useTranslation()
    const ref = useRef<HTMLDialogElement>(null)

    useEffect(() => {
        const dialog = ref.current
        if (!dialog) return
        if (open && !dialog.open) dialog.showModal()
        if (!open && dialog.open) dialog.close()
    }, [open])

    const steps = [
        { Icon: Share, text: t('sponsorInstall.iosStep1') },
        { Icon: SquarePlus, text: t('sponsorInstall.iosStep2') },
        { Icon: Check, text: t('sponsorInstall.iosStep3') },
    ]

    return (
        <dialog
            ref={ref}
            aria-labelledby="ios-install-title"
            onCancel={(e) => { e.preventDefault(); onClose() }}
            className="m-auto w-[min(100%-2rem,24rem)] rounded-card border-0 bg-surface p-0 text-ink shadow-xl"
        >
            <div className="flex flex-col gap-4 p-6">
                <h2 id="ios-install-title" className="m-0 font-display text-xl font-bold">{t('sponsorInstall.iosTitle')}</h2>
                <p className="m-0 text-[15px] text-ink-muted">{t('sponsorInstall.iosIntro')}</p>
                <ol className="m-0 flex list-none flex-col gap-3 p-0">
                    {steps.map(({ Icon, text }) => (
                        <li key={text} className="flex items-center gap-3 text-[15px] font-medium">
                            <IconBadge className="size-10"><Icon className="size-5" aria-hidden="true" /></IconBadge>
                            {text}
                        </li>
                    ))}
                </ol>
                <Button variant="primary" size="md" block onClick={onClose}>{t('sponsorCommon.close')}</Button>
            </div>
        </dialog>
    )
}
